import { Container, Item } from "./api";

// Array Remove - By John Resig (MIT Licensed)
// Ref: https://stackoverflow.com/questions/500606/deleting-array-elements-in-javascript-delete-vs-splice
export function remove<T>(items: T[], index: number) {
  const rest = items.slice(index + 1 || items.length);
  items.length = index < 0 ? items.length + index : index;
  return items.push.apply(items, rest);
}

export function totalContainerCount(c: Container): number {
  if (!c.containers) {
    return 0;
  }
  let count: number = c.containers.length;
  for (let i = 0; i < c.containers.length; i++) {
    count += totalContainerCount(c.containers[i]);
  }
  return count;
}

export function totalItemCount(c: Container): number {
  let count: number = c.items?.length || 0;
  if (!c.containers) {
    return count;
  }
  for (let i = 0; i < c.containers.length; i++) {
    count += totalItemCount(c.containers[i]);
  }
  return count;
}

interface searchContainerItemsProps {
  path?: string;
  containers?: string[];

  c: Container;
  term: string;
}

export function searchContainerItems({
  path,
  containers,
  c,
  term,
}: searchContainerItemsProps): ItemSearchResult[] {
  const items: ItemSearchResult[] = [];

  if (c.items) {
    for (let i = 0; i < c.items.length; i++) {
      const item = c.items[i];
      const normalizedTerm = term.toLocaleLowerCase();
      if (
        item.name.toLocaleLowerCase().includes(normalizedTerm) ||
        (item.description || "").includes(normalizedTerm)
      ) {
        items.push({
          path: path ? `${path}.${c.id}` : c.id,
          containers: containers ? [...containers, c.name] : ["Home", c.name],

          container: c.name,
          ...item,
        });
      }
    }
  }

  if (c.containers) {
    for (let i = 0; i < c.containers.length; i++) {
      items.push(
        ...searchContainerItems({
          path: path ? `${path}.${c.id}` : c.id,
          containers: containers ? [...containers, c.name] : ["Home", c.name],
          c: c.containers[i],
          term,
        })
      );
    }
  }

  return items;
}

export interface ItemSearchResult extends Item {
  path: string;
  container: string;
  containers: string[];
}
